import graphqlClient from "../../../apollo";

class LiquidacionProvider {

    liquidacionAgencia(mes, reporteStock, tipificado = false, estrategiaLiquidacion = 'TODAS') {
        return graphqlClient.query({
            query: require('./gql/Liquidacion/liquidacionAgencia.graphql'),
            fetchPolicy: "network-only",
            variables: {mes, reporteStock, tipificado, estrategiaLiquidacion}
        })
    }

    liquidacionAgenciaExport(mes, reporteStock, tipificado, estrategiaLiquidacion = 'TODAS') {
        return graphqlClient.query({
            query: require('./gql/Liquidacion/liquidacionAgenciaExport.graphql'),
            fetchPolicy: "network-only",
            variables: {mes, reporteStock, tipificado, estrategiaLiquidacion}
        })
    }


}

export default new LiquidacionProvider()

